<template>
  <div class="tl-page">

    <!-- ── Filter Bar ── -->
    <div class="tl-filters">
      <div class="tl-filters__selects">
        <select v-model="filters.year" class="tl-select tl-select--xs" @change="fetchServices(1)">
          <option value="">Year</option>
          <option v-for="o in yearOptions.slice(1)" :key="o.value" :value="o.value">{{ o.text }}</option>
        </select>
        <select v-model="filters.city" class="tl-select" @change="fetchServices(1)">
          <option value="">City</option>
          <option v-for="o in cityOptions.slice(1)" :key="o.value" :value="o.value">{{ o.text }}</option>
        </select>
        <select v-model="filters.item" class="tl-select tl-select--wide" @change="fetchServices(1)">
          <option value="">Item</option>
          <option v-for="o in itemOptions.slice(1)" :key="o.value" :value="o.value">{{ o.text }}</option>
        </select>
        <select v-model="filters.catagory" class="tl-select" @change="fetchServices(1)">
          <option value="">Category</option>
          <option v-for="o in catagoryOptions.slice(1)" :key="o.value" :value="o.value">{{ o.text }}</option>
        </select>
        <select v-model="filters.supplier" class="tl-select tl-select--wide" @change="fetchServices(1)">
          <option value="">Supplier</option>
          <option v-for="o in supplierOptions.slice(1)" :key="o.value" :value="o.value">{{ o.text }}</option>
        </select>
      </div>
      <div class="tl-filters__actions">
        <div class="tl-search">
          <svg class="tl-search__icon" viewBox="0 0 20 20" fill="none">
            <circle cx="8.5" cy="8.5" r="5.5" stroke="#9ca3af" stroke-width="1.6" />
            <path d="M13 13l3 3" stroke="#9ca3af" stroke-width="1.6" stroke-linecap="round" />
          </svg>
          <input v-model="searchQuery" class="tl-search__input" placeholder="Search services…"
            @input="debouncedFetchServices" />
        </div>
        <span class="tl-count">{{ pagination.totalServices }} Services</span>
        <button class="tl-btn tl-btn--ghost" v-b-tooltip.hover title="Reset all filters" @click="resetFilters">↺
          Reset</button>
        <button class="tl-btn tl-btn--primary" @click="showForm = true; currentService = null">+ Add Service</button>
      </div>
    </div>

    <!-- ── Loading ── -->
    <div v-if="loading" class="tl-loading">
      <div class="tl-spinner"></div>
      <span>Loading services…</span>
    </div>

    <!-- ── Table ── -->
    <div v-else class="tl-table-card">
      <div class="tl-table-scroll">
        <table class="tl-table">
          <thead>
            <tr>
              <th class="tl-th tl-th--check"><input type="checkbox" v-model="isAllSelected" @change="selectAll" /></th>
              <th class="tl-th tl-th--sort" @click="setSort('id')">#<span class="tl-sort-arrow">{{
                sortField === 'id' ? (sortOrder === 'asc' ? '↑' : '↓') : '' }}</span></th>
              <th class="tl-th tl-th--sort" @click="setSort('item')">Item<span class="tl-sort-arrow">{{
                sortField === 'item' ? (sortOrder === 'asc' ? '↑' : '↓') : '' }}</span></th>
              <th class="tl-th tl-th--sort" @click="setSort('year')">Year<span class="tl-sort-arrow">{{
                sortField === 'year' ? (sortOrder === 'asc' ? '↑' : '↓') : '' }}</span></th>
              <th class="tl-th">Cities</th>
              <th class="tl-th">Adult Gross</th>
              <th class="tl-th">Child Gross</th>
              <th class="tl-th">Adult Net</th>
              <th class="tl-th">Child Net</th>
              <th class="tl-th">Price (Gross)</th>
              <th class="tl-th">Type</th>
              <th class="tl-th">Tax</th>
              <th class="tl-th">Rate</th>
              <th class="tl-th">Category</th>
              <th class="tl-th">Remarks</th>
              <th class="tl-th">Cancellation</th>
              <th class="tl-th">Supplier</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="service in services" :key="service.id" class="tl-row"
              :class="{ 'tl-row--selected': selectedServices.includes(service.id) }"
              @contextmenu.prevent="showContextMenu($event, service)" @click="toggleRowSelection(service.id)"
              @mouseenter="highlightRow(service, false)" @mouseleave="highlightRow(service, true)">
              <td class="tl-td tl-td--check"><input type="checkbox" v-model="selectedServices" :value="service.id" />
              </td>
              <td class="tl-td tl-td--id">{{ service.id }}</td>
              <td class="tl-td tl-td--name">{{ service.attributes.item }}</td>
              <td class="tl-td"><span class="tl-pill tl-pill--green">{{ service.attributes.year }}</span></td>
              <td class="tl-td">
                <div class="tl-cities">
                  <span v-for="city in service.attributes.cities.data" :key="city.id" class="tl-pill tl-pill--purple">{{
                    city.attributes.city }}</span>
                </div>
              </td>
              <td class="tl-td">{{ formatPrice(service.attributes.adultPrice_gross,
                service.attributes.cities.data?.[0]?.attributes?.city) }}</td>
              <td class="tl-td">{{ formatPrice(service.attributes.childPrice_gross,
                service.attributes.cities.data?.[0]?.attributes?.city) }}</td>
              <td class="tl-td">{{ formatPrice(service.attributes.adultPrice_net,
                service.attributes.cities.data?.[0]?.attributes?.city) }}</td>
              <td class="tl-td">{{ formatPrice(service.attributes.childPrice_net,
                service.attributes.cities.data?.[0]?.attributes?.city) }}</td>
              <td class="tl-td">{{ formatPrice(service.attributes.price,
                service.attributes.cities.data?.[0]?.attributes?.city) }}</td>
              <td class="tl-td"><span v-if="service.attributes.type" class="tl-pill tl-pill--blue">{{
                service.attributes.type }}</span><span v-else class="tl-muted">—</span></td>
              <td class="tl-td">{{ service.attributes.tax || '—' }}</td>
              <td class="tl-td">{{ service.attributes.rate != null ? service.attributes.rate + '%' : '—' }}</td>
              <td class="tl-td">{{ service.attributes.catagory || '—' }}</td>
              <td class="tl-td tl-td--wrap">{{ service.attributes.remarks || '—' }}</td>
              <td class="tl-td tl-td--wrap">{{ service.attributes.cancellation || '—' }}</td>
              <td class="tl-td">{{ service.attributes.supplier || '—' }}</td>
            </tr>
            <tr v-if="!services.length">
              <td colspan="17" class="tl-empty">No services found for the current filters.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ── Pagination ── -->
    <b-pagination v-if="!loading && pagination.totalPages > 1" v-model="pagination.currentPage"
      :total-rows="pagination.totalServices" :per-page="pagination.perPage" align="center" class="mt-3"
      @change="fetchServices"></b-pagination>

    <!-- ── Context Menu ── -->
    <div v-if="contextMenuVisible" :style="{ top: `${contextMenuPosition.y}px`, left: `${contextMenuPosition.x}px` }"
      class="tl-ctx" ref="contextMenu">
      <button class="tl-ctx__item" @click="editService(contextMenuService)">✏️ Edit</button>
      <button class="tl-ctx__item tl-ctx__item--danger" @click="confirmDelete(contextMenuService)">🗑 Delete</button>
      <button class="tl-ctx__item" @click="promptCloneService(contextMenuService)">📋 Clone</button>
      <button class="tl-ctx__item" @click="exportSelectedServices">📊 Export</button>
      <button class="tl-ctx__item" @click="checkServiceUsage(contextMenuService)">🔍 Check Usage</button>
    </div>

    <!-- ── Service Form ── -->
    <ServiceForm v-if="showForm" :service="currentService" :cities="cities"
      @close="showForm = false; currentService = null" @service-added="fetchServices" />

    <!-- ── Modals ── -->
    <b-modal v-model="showCloneModal" title="Clone Service" @ok="cloneService" centered header-class="tl-modal-header"
      body-class="tl-modal-body" footer-class="tl-modal-footer">
      <div class="tl-form-group">
        <label class="tl-label">New Item Name</label>
        <input v-model="cloneItem" type="text" placeholder="Enter item name" class="tl-input" />
      </div>
      <div class="tl-form-group mt-4">
        <label class="tl-label">Year</label>
        <input v-model="newYear" type="number" placeholder="Enter year" class="tl-input" />
      </div>

      <template #modal-footer="{ ok, cancel }">
        <button class="tl-btn tl-btn--ghost" @click="cancel()">Cancel</button>
        <button class="tl-btn tl-btn--primary" @click="ok()">Clone Service</button>
      </template>
    </b-modal>

    <b-modal v-model="showTourModal" title="Service Usage" centered header-class="tl-modal-header"
      body-class="tl-modal-body" footer-class="tl-modal-footer">
      <div v-if="tourResults.length > 0">
        <p class="tl-label-sub mb-3">Used in the following tours:</p>
        <div class="tl-usage-list">
          <div v-for="tour in tourResults" :key="tour.id" class="tl-usage-item">
            <span class="tl-usage-id">#{{ tour.id }}</span>
            <span class="tl-usage-name">{{ tour.name || 'Unknown' }}</span>
          </div>
        </div>
      </div>
      <div v-else class="text-center py-4">
        <div class="text-muted mb-2" style="font-size: 2rem;"><i class="fas fa-info-circle"></i></div>
        <p class="text-muted">This service is not used in any tours.</p>
      </div>
      <template #modal-footer="{ cancel }">
        <button class="tl-btn tl-btn--ghost" @click="cancel()">Close</button>
      </template>
    </b-modal>

    <b-modal v-model="showDeleteModal" title="Confirm Deletion" @ok="deleteSelectedServices" centered
      header-class="tl-modal-header" body-class="tl-modal-body" footer-class="tl-modal-footer">
      <div class="text-center py-3">
        <div class="mb-3 text-danger" style="font-size: 2.5rem;">
          <i class="fas fa-exclamation-circle"></i>
        </div>
        <h5 class="font-weight-bold mb-2">Confirm Deletion</h5>
        <p class="text-muted mb-0">Are you sure you want to delete the selected service(s)?</p>
        <p class="small text-danger mt-2">This action cannot be undone.</p>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <button class="tl-btn tl-btn--ghost" @click="cancel()">Cancel</button>
        <button class="tl-btn tl-btn--danger" @click="ok()">Delete Services</button>
      </template>
    </b-modal>
    <b-toast v-model="toastVisible" id="feedback-toast" :title="toastTitle" :variant="toastVariant" solid>
      {{ toastMessage }}
    </b-toast>

  </div>
</template>

<script>
import ServiceForm from './ServiceForm.vue';
import { formatPrice } from '../Helper/PriceDisplay.js';
import { exportSelectedServices } from '../Helper/GenerateServiceexcel.js';
import _ from 'lodash';

export default {
  components: {
    ServiceForm
  },
  data() {
    return {
      services: [],
      selectedServices: [],
      loading: false,
      showForm: false,
      showCloneModal: false,
      showDeleteModal: false,
      showTourModal: false,
      tourResults: [],
      currentService: null,
      newYear: '',
      cloneItem: '',
      toastVisible: false,
      toastTitle: '',
      toastMessage: '',
      toastVariant: '',
      searchQuery: '',
      filters: {
        year: '',
        city: '',
        item: '',
        supplier: '',
        catagory: ''
      },
      cities: [],
      contextMenuVisible: false,
      contextMenuPosition: { x: 0, y: 0 },
      contextMenuService: null,
      sortField: 'id',
      sortOrder: 'asc',
      pagination: {
        currentPage: 1,
        perPage: 25,
        totalServices: 0,
        totalPages: 0
      },
      optionsCache: {
        years: [],
        cities: [],
        items: [],
        suppliers: [],
        catagories: []
      }
    };
  },
  computed: {
    yearOptions() {
      return [{ value: '', text: 'Year' }, ...this.optionsCache.years.map(year => ({ value: year, text: year }))];
    },
    cityOptions() {
      return [{ value: '', text: 'City' }, ...this.optionsCache.cities.map(city => ({ value: city, text: city }))];
    },
    itemOptions() {
      return [{ value: '', text: 'Item' }, ...this.optionsCache.items.map(item => ({ value: item, text: item }))];
    },
    supplierOptions() {
      return [{ value: '', text: 'Supplier' }, ...this.optionsCache.suppliers.map(supplier => ({ value: supplier, text: supplier }))];
    },
    catagoryOptions() {
      return [{ value: '', text: 'Category' }, ...this.optionsCache.catagories.map(catagory => ({ value: catagory, text: catagory }))];
    }
  },
  created() {
    this.loadFilters();
    this.fetchOptions();
    this.fetchCities();
    this.fetchServices(); // Call after loading filters
    this.debouncedFetchServices = _.debounce(() => this.fetchServices(1), 300);
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    formatPrice,
    async exportSelectedServices() {
      if (this.selectedServices.length === 0) {
        this.showToast('Export Failed', 'No services selected for export!', 'warning');
        return;
      }

      this.loading = true;
      try {
        let allServices = [];
        let page = 1;
        const limit = 100;
        let hasMore = true;

        while (hasMore) {
          let url = `/api/services?populate[cities][fields][0]=city&fields[0]=item&fields[1]=year&fields[2]=adultPrice_gross&fields[3]=childPrice_gross&fields[4]=adultPrice_net&fields[5]=childPrice_net&fields[6]=price&fields[7]=type&fields[8]=tax&fields[9]=rate&fields[10]=catagory&fields[11]=remarks&fields[12]=cancellation&fields[13]=supplier&pagination[start]=${(page - 1) * limit}&pagination[limit]=${limit}`;
          // Apply filters, search query, and sorting as above
          if (this.filters.year) url += `&filters[year][$eq]=${encodeURIComponent(this.filters.year)}`;
          // ... other filters and search query ...
          url += `&sort=${this.sortField}:${this.sortOrder}`;

          const response = await this.$xhr.get(url);
          const services = response.data.data.map(service => ({
            id: service.id,
            attributes: { ...service.attributes, cities: service.attributes.cities || { data: [] } }
          }));

          allServices = allServices.concat(services);
          hasMore = services.length === limit;
          page++;
        }

        const selectedRows = this.selectedServices.length === this.services.length
          ? allServices
          : allServices.filter(service => this.selectedServices.includes(service.id));

        if (selectedRows.length === 0) {
          this.showToast('Export Failed', 'No matching services selected for export!', 'warning');
          return;
        }

        exportSelectedServices(selectedRows);
        this.showToast('Success', 'Services exported successfully!', 'success');
      } catch (error) {
        console.error('Error exporting services:', error);
        this.showToast('Error', 'Failed to export services. Please try again.', 'danger');
      } finally {
        this.loading = false;
      }
    },
    async fetchServices(page = this.pagination.currentPage) {
      this.loading = true;
      try {
        const start = (page - 1) * this.pagination.perPage;
        const queryParams = new URLSearchParams();

        // Populate fields
        queryParams.append('populate[cities][fields][0]', 'city');

        const fields = [
          'item', 'year', 'adultPrice_gross', 'childPrice_gross',
          'adultPrice_net', 'childPrice_net', 'price', 'type',
          'tax', 'rate', 'catagory', 'remarks',
          'cancellation', 'supplier'
        ];

        fields.forEach((field, index) => {
          queryParams.append(`fields[${index}]`, field);
        });

        // Pagination
        queryParams.append('pagination[start]', start);
        queryParams.append('pagination[limit]', this.pagination.perPage);

        // Filters
        if (this.filters.year) queryParams.append('filters[year][$eq]', this.filters.year);
        if (this.filters.city) queryParams.append('filters[cities][city][$eq]', this.filters.city);
        if (this.filters.item) queryParams.append('filters[item][$containsi]', this.filters.item);
        if (this.filters.supplier) queryParams.append('filters[supplier][$containsi]', this.filters.supplier);
        if (this.filters.catagory) queryParams.append('filters[catagory][$containsi]', this.filters.catagory);

        // Search Query
        if (this.searchQuery.trim()) {
          const query = this.searchQuery.trim();
          queryParams.append('filters[$or][0][item][$containsi]', query);
          queryParams.append('filters[$or][1][supplier][$containsi]', query);
          queryParams.append('filters[$or][2][catagory][$containsi]', query);
          queryParams.append('filters[$or][3][remarks][$containsi]', query);
          queryParams.append('filters[$or][4][cancellation][$containsi]', query);
          queryParams.append('filters[$or][5][cities][city][$containsi]', query);
          if (!isNaN(query)) {
            queryParams.append('filters[$or][6][year][$eq]', query);
          }
        }

        // Sorting
        queryParams.append('sort', `${this.sortField}:${this.sortOrder}`);

        // Final URL
        const url = `/api/services?${queryParams.toString()}`;

        // API call
        const response = await this.$xhr.get(url);

        // Map response
        this.services = response.data.data.map(service => ({
          id: service.id,
          attributes: {
            ...service.attributes,
            cities: service.attributes.cities || { data: [] },
            item: service.attributes.item || '',
            year: service.attributes.year || '',
            adultPrice_gross: service.attributes.adultPrice_gross || null,
            childPrice_gross: service.attributes.childPrice_gross || null,
            adultPrice_net: service.attributes.adultPrice_net || null,
            childPrice_net: service.attributes.childPrice_net || null,
            price: service.attributes.price || null,
            type: service.attributes.type || '',
            tax: service.attributes.tax || '',
            rate: service.attributes.rate || null,
            catagory: service.attributes.catagory || '',
            remarks: service.attributes.remarks || '',
            cancellation: service.attributes.cancellation || '',
            supplier: service.attributes.supplier || ''
          }
        }));

        // Pagination
        this.pagination = {
          currentPage: page,
          perPage: this.pagination.perPage,
          totalServices: response.data.meta.pagination.total,
          totalPages: Math.ceil(response.data.meta.pagination.total / this.pagination.perPage)
        };
      } catch (error) {
        console.error('Error fetching services:', error);
        this.showToast('Error', 'Failed to load services. Please try again.', 'danger');
        this.services = [];
        this.pagination.totalServices = 0;
        this.pagination.totalPages = 0;
      } finally {
        this.loading = false;
      }
    },

    async fetchOptions() {
      try {
        const response = await this.$xhr.get('/api/services/filters');
        const data = response.data;
        this.optionsCache.years = data.years || [];
        this.optionsCache.cities = data.cities || [];
        this.optionsCache.items = data.items || [];
        this.optionsCache.suppliers = data.suppliers || [];
        this.optionsCache.catagories = data.catagories || [];
      } catch (error) {
        console.error('Error fetching filter options:', error);
        this.showToast('Error', 'Failed to load filter options.', 'danger');
      }
    },
    async fetchCities() {
      try {
        const response = await this.$xhr.get('/api/cities?fields[0]=city&pagination[pageSize]=1000&sort[0]=city:asc');
        this.cities = response.data.data;
      } catch (error) {
        console.error('Error fetching cities:', error);
        this.showToast('Error', 'Failed to load cities.', 'danger');
      }
    },
    setSort(field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortOrder = 'asc';
      }
      this.saveFilters(); // Save sort state when sorting changes
      this.fetchServices(1);
    },
    showContextMenu(event, service) {
      event.preventDefault();
      this.contextMenuVisible = true;
      this.contextMenuPosition = { x: event.clientX, y: event.clientY };
      this.contextMenuService = {
        id: service.id,
        attributes: {
          ...service.attributes,
          cities: service.attributes.cities || { data: [] }
        }
      };
      console.log('Selected service for context menu:', this.contextMenuService);
    },
    handleClickOutside(event) {
      const contextMenu = this.$refs.contextMenu;
      if (contextMenu && !contextMenu.contains(event.target)) {
        this.contextMenuVisible = false;
        this.contextMenuService = null;
      }
    },
    editService(service) {
      this.currentService = {
        id: service.id,
        attributes: {
          ...service.attributes,
          cities: service.attributes.cities || { data: [] }
        }
      };
      this.showForm = true;
      this.contextMenuVisible = false;
    },
    confirmDelete(service) {
      this.contextMenuService = service;
      this.selectedServices = [service.id];
      this.checkIfServicesInUseInTours([service.id]).then(inUseServices => {
        if (inUseServices.length > 0) {
          this.showToast('Abort Delete', `The service "${inUseServices.join(', ')}" is currently in use in tours and cannot be deleted.`, 'danger');
        } else {
          this.showDeleteModal = true;
        }
      });
    },
    async checkIfServicesInUseInTours(serviceIds) {
      try {
        const response = await this.$xhr.get('/api/tours?populate[item][fields][0]=item');
        const tours = response.data.data;
        const inUseServiceNames = [];
        for (const serviceId of serviceIds) {
          const service = this.services.find(s => s.id === serviceId);
          if (!service) continue;
          const isInUse = tours.some(tour =>
            tour.attributes.item?.data?.some(item => item.id === serviceId)
          );
          if (isInUse) {
            inUseServiceNames.push(service.attributes.item);
          }
        }
        return inUseServiceNames;
      } catch (error) {
        console.error('Error checking service usage:', error);
        this.showToast('Error', 'Failed to check service usage.', 'danger');
        return [];
      }
    },
    async deleteSelectedServices() {
      try {
        await Promise.all(
          this.selectedServices.map(serviceId => this.$xhr.delete(`/api/services/${serviceId}`))
        );
        await this.fetchServices();
        this.selectedServices = [];
        this.showDeleteModal = false;
        this.showToast('Success', 'Service(s) deleted successfully!', 'success');
      } catch (error) {
        console.error('Error deleting services:', error);
        this.showToast('Error', 'Failed to delete service(s). Please try again.', 'danger');
      }
    },
    async checkServiceUsage(service) {
      try {
        const response = await this.$xhr.get('/api/tours?populate[item][fields][0]=item');
        const tours = response.data.data;
        this.tourResults = tours
          .filter(tour => tour.attributes.item?.data?.some(item => item.id === service.id))
          .map(tour => ({
            id: tour.id,
            name: tour.attributes.tourName || 'Unknown'
          }));
        this.showTourModal = true;
      } catch (error) {
        console.error('Error checking service usage:', error);
        this.showToast('Error', 'Failed to check service usage.', 'danger');
      }
    },
    promptCloneService(service) {
      this.currentService = {
        id: service.id,
        attributes: {
          ...service.attributes,
          cities: service.attributes.cities || { data: [] }
        }
      };
      this.cloneItem = service.attributes.item;
      this.newYear = service.attributes.year;
      this.showCloneModal = true;
      this.contextMenuVisible = false;
    },
    async cloneService() {
      if (!this.newYear || !this.cloneItem) {
        this.showToast('Warning', 'Please enter both item name and a new year.', 'warning');
        return;
      }
      try {
        const existingServiceResponse = await this.$xhr.get(
          `/api/services?filters[item][$eq]=${encodeURIComponent(this.cloneItem)}&filters[year][$eq]=${encodeURIComponent(this.newYear)}`
        );
        if (existingServiceResponse.data.data.length > 0) {
          this.showToast('Clone Aborted', 'This service already exists for the specified year.', 'danger');
          return;
        }
        const cityIds = this.currentService.attributes.cities?.data?.map(city => city.id) || [];
        const requestData = {
          data: {
            ...this.currentService.attributes,
            item: this.cloneItem,
            year: String(this.newYear),
            cities: cityIds, // Send as array of IDs
            adultPrice_gross: this.currentService.attributes.adultPrice_gross || null,
            childPrice_gross: this.currentService.attributes.childPrice_gross || null,
            adultPrice_net: this.currentService.attributes.adultPrice_net || null,
            childPrice_net: this.currentService.attributes.childPrice_net || null,
            price: this.currentService.attributes.price || null,
            type: this.currentService.attributes.type || '',
            tax: this.currentService.attributes.tax || '',
            rate: this.currentService.attributes.rate || null,
            catagory: this.currentService.attributes.catagory || '',
            remarks: this.currentService.attributes.remarks || '',
            cancellation: this.currentService.attributes.cancellation || '',
            supplier: this.currentService.attributes.supplier || ''
          }
        };
        await this.$xhr.post('/api/services', requestData);
        await this.fetchServices();
        await this.fetchOptions();
        this.showCloneModal = false;
        this.newYear = '';
        this.cloneItem = '';
        this.showToast('Success', 'Service cloned successfully!', 'success');
      } catch (error) {
        console.error('Error cloning service:', error);
        this.showToast('Error', 'Failed to clone service.', 'danger');
      }
    },
    async selectAll(event) {
      if (event.target.checked) {
        this.loading = true;
        try {
          let url = `/api/services?fields[0]=id`;
          if (this.filters.year) url += `&filters[year][$eq]=${encodeURIComponent(this.filters.year)}`;
          if (this.filters.city) url += `&filters[cities][city][$eq]=${encodeURIComponent(this.filters.city)}`;
          if (this.filters.item) url += `&filters[item][$containsi]=${encodeURIComponent(this.filters.item)}`;
          if (this.filters.supplier) url += `&filters[supplier][$containsi]=${encodeURIComponent(this.filters.supplier)}`;
          if (this.filters.catagory) url += `&filters[catagory][$containsi]=${encodeURIComponent(this.filters.catagory)}`;
          if (this.searchQuery.trim()) {
            const encodedQuery = encodeURIComponent(this.searchQuery.trim());
            url += `&filters[$or][0][item][$containsi]=${encodedQuery}`;
            url += `&filters[$or][1][supplier][$containsi]=${encodedQuery}`;
            url += `&filters[$or][2][catagory][$containsi]=${encodedQuery}`;
            url += `&filters[$or][3][remarks][$containsi]=${encodedQuery}`;
            url += `&filters[$or][4][cancellation][$containsi]=${encodedQuery}`;
            url += `&filters[$or][5][cities][city][$containsi]=${encodedQuery}`;
            if (!isNaN(this.searchQuery.trim())) {
              url += `&filters[$or][6][year][$eq]=${encodedQuery}`;
            }
          }
          const response = await this.$xhr.get(url);
          this.selectedServices = response.data.data.map(service => service.id);
        } catch (error) {
          console.error('Error selecting all services:', error);
          this.showToast('Error', 'Failed to select all services.', 'danger');
          this.selectedServices = [];
        } finally {
          this.loading = false;
        }
      } else {
        this.selectedServices = [];
      }
    },
    toggleRowSelection(serviceId) {
      const index = this.selectedServices.indexOf(serviceId);
      if (index === -1) {
        this.selectedServices.push(serviceId);
      } else {
        this.selectedServices.splice(index, 1);
      }
    },
    highlightRow(service, isHovered) {
      service.isSelected = isHovered;
    },
    resetFilters() {
      this.filters = { year: '', city: '', item: '', supplier: '', catagory: '' };
      this.searchQuery = '';
      this.sortField = 'id';
      this.sortOrder = 'asc';
      localStorage.removeItem('lastServiceAppliedFilters');
      this.fetchServices(1);
    },
    saveFilters() {
      localStorage.setItem('lastServiceAppliedFilters', JSON.stringify({
        filters: this.filters,
        searchQuery: this.searchQuery,
        sortField: this.sortField,
        sortOrder: this.sortOrder
      }));
    },
    loadFilters() {
      const savedFilters = localStorage.getItem('lastServiceAppliedFilters');
      if (savedFilters) {
        const parsed = JSON.parse(savedFilters);
        this.filters = parsed.filters || { year: '', city: '', item: '', supplier: '', catagory: '' };
        this.searchQuery = parsed.searchQuery || '';
        this.sortField = parsed.sortField || 'id';
        this.sortOrder = parsed.sortOrder || 'asc';
      }
    },
    showToast(title, message, variant) {
      this.toastTitle = title;
      this.toastMessage = message;
      this.toastVariant = variant;
      this.toastVisible = true;
    }
  },
  watch: {
    filters: {
      handler() {
        this.saveFilters();
      },
      deep: true
    },
    searchQuery() {
      this.saveFilters();
    }
  }
};
</script>

<style scoped>
/* ────────────── Page ────────────── */
.tl-page {
  padding: 16px 18px;
  font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
}

/* ────────────── Filter Bar ────────────── */
.tl-filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 10px 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .05);
}

.tl-filters__selects {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.tl-filters__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.tl-select {
  height: 32px;
  min-width: 130px;
  max-width: 160px;
  font-size: .8rem;
  padding: 0 8px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #f9fafb;
  color: #374151;
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
}

.tl-select:focus {
  border-color: #E2923D;
  box-shadow: 0 0 0 3px rgba(226, 146, 61, .15);
}

.tl-select--wide {
  min-width: 170px;
  max-width: 210px;
}

.tl-select--xs {
  min-width: 80px;
  max-width: 95px;
}

/* Search */
.tl-search {
  position: relative;
}

.tl-search__icon {
  position: absolute;
  left: 9px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
}

.tl-search__input {
  height: 32px;
  padding: 0 10px 0 30px;
  min-width: 190px;
  font-size: .82rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #f9fafb;
  outline: none;
  transition: border-color .15s;
}

.tl-search__input:focus {
  border-color: #E2923D;
  box-shadow: 0 0 0 3px rgba(226, 146, 61, .15);
  background: #fff;
}

.tl-count {
  background: #fff3e0;
  color: #b45309;
  font-size: .75rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
  border: 1px solid #fde68a;
}

/* Buttons */
.tl-btn {
  height: 32px;
  padding: 0 14px;
  font-size: .8rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity .15s;
  white-space: nowrap;
}

.tl-btn:hover {
  opacity: .88;
}

.tl-btn--primary {
  background: #E2923D;
  color: #fff;
}

.tl-btn--ghost {
  background: #f1f3f5;
  color: #374151;
  border: 1px solid #dee2e6;
}

/* ────────────── Loading ────────────── */
.tl-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 48px 0;
  color: #9ca3af;
  font-size: .88rem;
}

.tl-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e9ecef;
  border-top-color: #E2923D;
  border-radius: 50%;
  animation: tl-spin .7s linear infinite;
}

@keyframes tl-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ────────────── Table Card ────────────── */
.tl-table-card {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .06);
}

.tl-table-scroll {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 68vh;
}

/* ────────────── Table ────────────── */
.tl-table {
  width: 100%;
  border-collapse: collapse;
  font-size: .82rem;
  white-space: nowrap;
}

/* Head */
.tl-table thead tr {
  background: #E2923D;
  position: sticky;
  top: 0;
  z-index: 2;
}

.tl-th {
  padding: 10px 12px;
  text-align: center;
  color: #fff;
  font-weight: 700;
  font-size: .72rem;
  text-transform: uppercase;
  letter-spacing: .05em;
  border: none;
  white-space: nowrap;
}

.tl-th--sort {
  cursor: pointer;
  user-select: none;
}

.tl-th--sort:hover {
  background: rgba(0, 0, 0, .1);
}

.tl-th--check {
  width: 38px;
}

.tl-sort-arrow {
  margin-left: 4px;
  opacity: .85;
}

/* Body */
.tl-td {
  padding: 8px 12px;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
  text-align: center;
  vertical-align: middle;
}

.tl-td--check {
  width: 38px;
}

.tl-td--id {
  width: 46px;
  font-size: .75rem;
  color: #9ca3af;
}

.tl-td--name {
  text-align: left;
  max-width: 220px;
  white-space: normal;
  font-weight: 600;
  color: #111827;
}

.tl-td--wrap {
  max-width: 180px;
  white-space: normal;
  text-align: left;
}

.tl-row {
  cursor: pointer;
  transition: background .1s;
}

.tl-row:hover .tl-td {
  background: #fff8f1;
}

.tl-row--selected .tl-td {
  background: #fff3e0 !important;
}

.tl-muted {
  color: #9ca3af;
}

.tl-empty {
  text-align: center;
  padding: 40px;
  color: #9ca3af;
  font-size: .88rem;
}

/* Pills */
.tl-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: .72rem;
  font-weight: 700;
}

.tl-pill--blue {
  background: #e0e7ff;
  color: #3730a3;
}

.tl-pill--green {
  background: #dcfce7;
  color: #166534;
}

.tl-pill--purple {
  background: #f3e8ff;
  color: #6b21a8;
}

.tl-cities {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  justify-content: center;
}

/* ────────────── Context Menu ────────────── */
.tl-ctx {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, .13);
  padding: 5px;
  min-width: 155px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.tl-ctx__item {
  display: block;
  width: 100%;
  padding: 8px 14px;
  font-size: .83rem;
  text-align: left;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: #374151;
  transition: background .12s;
}

.tl-ctx__item:hover {
  background: #fff8f1;
  color: #E2923D;
}

.tl-ctx__item--danger:hover {
  background: #fff0f0;
  color: #e03131;
}

/* ────────────── Modal Enhancements ────────────── */
:deep(.tl-modal-header) {
  border-bottom: 1px solid #f1f5f9;
  padding: 20px 24px;
}

:deep(.tl-modal-header .modal-title) {
  font-size: 1.1rem;
  font-weight: 800;
  color: #111827;
}

:deep(.tl-modal-body) {
  padding: 24px;
}

:deep(.tl-modal-footer) {
  border-top: 1px solid #f1f5f9;
  padding: 16px 24px;
  display: flex !important;
  justify-content: flex-end;
  gap: 12px;
}

.tl-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tl-label {
  font-size: 0.68rem;
  text-transform: uppercase;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.05em;
  margin: 0;
}

.tl-label-sub {
  font-size: 0.75rem;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.tl-input {
  height: 34px;
  width: 100%;
  padding: 0 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: .82rem;
  outline: none;
  transition: all .2s;
  background: #f9fafb;
}

.tl-input:focus {
  border-color: #E2923D;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(226, 146, 61, 0.15);
}

.tl-usage-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tl-usage-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.tl-usage-id {
  font-weight: 700;
  color: #E2923D;
  font-family: monospace;
}

.tl-usage-name {
  font-weight: 600;
  color: #334155;
}

.tl-btn--danger {
  background: #ef4444;
  color: #fff;
  border: none;
}
</style>
